import styled from "styled-components";
import usePracticesByClientSelected from "../PracticesByClientSelected/hooks/usePracticesByClientSelected";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ClientSelected = ({ showButton = true, theme }) => {
  const { client, countSelectedPractices, togglePracticeModal } =
    usePracticesByClientSelected();

  return client ? (
    <Wrapper>
      <strong style={{ fontFamily: theme?.fontFamily }}>
        {client.clientName} - practices selected: {countSelectedPractices}
      </strong>
      {showButton && (
        <button
          className="btn btn-sm ml-3"
          onClick={togglePracticeModal}
          style={{
            backgroundColor: theme?.primary,
            color: theme?.white,
            fontFamily: theme?.fontFamily,
          }}
        >
          Show
        </button>
      )}
    </Wrapper>
  ) : (
    "*No Practice Selected*"
  );
};

export default ClientSelected;
